import React, { useEffect } from "react";
import "../digital-commerce/digital-commerce.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import BI_IMG from "../../assets/BI_IMG.jpg";
import BI_Goals from "../../assets/BI_Goals.jpg";
import Data_Integration from "../../assets/Data_Integration.jpg";
import Customization from "../../assets/Customization.jpg";
import Training from "../../assets/Training.jpg";
import Security from "../../assets/Security.jpg";
import Performance from "../../assets/Performance.jpg";
import BI_Img2 from "../../assets/BI_Img2.jpg";
import { Helmet } from "react-helmet";

// Define the AccordionItem component
const AccordionItem = ({ title, content, index, openIndex, setOpenIndex }) => {
  const isOpen = index === openIndex;

  const toggleAccordion = () => {
    setOpenIndex(isOpen ? null : index);
  };
  return (
    <div className="accordion-item">
      <div
        className="accordion-title"
        type="text"
        onClick={toggleAccordion}
        style={{ fontSize: "16px", cursor: "pointer" }}
      >
        <strong>{isOpen ? "- " : "+ "}</strong> <strong>{title}</strong>
      </div>
      {isOpen && <div className="accordion-content">{content}</div>}
    </div>
  );
};

const ListItem = () => {
  const additionalSteps = [
    "Identify the goals and objectives of the BI or Analytics project",
    "Determine the scope of the project and the data sources that will be used",
    "Define the metrics and KPIs that will be tracked",
    "Analyze  current data infrastructure and identify any gaps that need to be addressed",
    "Assess the quality and completeness of the data",
    "Determine the technology stack that will be used for the project",
    "Develop a plan for data governance and security",
    "Define the project timeline and milestones",
  ];
  return (
    <div className="col-lg-6 col-12">
      {/* ... (other code) */}
      <div className="new-para" style={{ whiteSpace: "nowrap" }}>
        {additionalSteps.map((step, index) => (
          <p key={index}>
            <span className="circle-number">{index + 1}</span>
            <span>{step}</span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default function Digital_Commerce() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  const [openIndex, setOpenIndex] = React.useState(null);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
  };
  var settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
  };
  var settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <>
      <Helmet>
        <meta property="og:locale" content="en_US" /><meta property="og:type" content="Page" /><meta property="og:title" content="Business Intelligence (BI) & Analytics Solutions - Dahooks" /><meta property="og:description" content="Dahooks offers specialized Business Intelligence (BI) and analytics solutions to support companies in making decisions that are well-informed and based on timely insights from their data." /><meta property="og:url" content="https://dahooks.com/web-dev" /><meta property="og:site_name" content="DAHOOKS" /><meta property="og:image" content="https://dahooks.com/static/media/Dahookslogo.22e49eeb708254417c39.png" /><meta property="og:image:width" content="1500" /><meta property="og:image:height" content="800" /><meta name="twitter:card" content="summary_large_image" /><meta name="twitter:site" content="@dahookstech" /><meta name="twitter:title" content="Business Intelligence (BI) & Analytics Solutions - Dahooks" /><meta name="twitter:description" content="Dahooks offers specialized Business Intelligence (BI) and analytics solutions to support companies in making decisions that are well-informed and based on timely insights from their data." /><meta name="twitter:image" content="https://dahooks.com/static/media/Dahookslogo.22e49eeb708254417c39.png" />
        <title>Business Intelligence (BI) & Analytics Solutions - Dahooks</title>
        <link rel="canonical" href="https://dahooks.com/BI" />
      </Helmet>
      <div className="container pt-5">
        <div className="row ">
          <div className="col-lg-12 mt-5 py-4">
            <div className="contact-banner-heading p-lg-4  mt-5">
              <h1 style={{ color: "#f4990b" }}>Analytics & Business Intelligence Solutions</h1>
              <div className="headings" style={{fontSize: "28px",textAlign: "center",lineHeight: "70px",}}>
                Utilize BI and analytics to transform business, and lead with assurance.
              </div>
              <p>
                Dahooks offers specialized BI and analytics solutions to support companies in making decisions that are well-informed and based on timely insights from their data. Their specialized crew promotes innovation for expansion prospects and guarantees quantifiable outcomes.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <img src={BI_IMG} width="100%" />
          </div>
        </div>
      </div>
      <div className="background py-5">
        <div className="container ">
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="tagline">
                <p style={{ color: "#f4990b" }}>DATA ADVANTAGE</p>
                <h1><strong>Analytics and BI<br /> Tools</strong></h1>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="service-content">
                <p><strong>Gathering and combining data</strong></p>
                <div className="service-points">
                  <ul>
                    <li>Gathering information from multiple sources</li>
                    <li>Combining data from several systems</li>
                  </ul>
                </div>
                <p><strong>Information warehousing</strong></p>
                <div className="service-points">
                  <ul>
                    <li>keeping a lot of data</li>
                    <li>Data organization for effective analysis and retrieval</li>
                  </ul>
                </div>
                <p><strong>Data reporting and analysis</strong></p>
                <div className="service-points">
                  <ul>
                    <li>Examining data to find patterns and insights</li>
                    <li>Producing summaries and illustrations to convey discoveries</li>
                  </ul>
                </div>
                <p><strong>Predictive analytics and data mining</strong></p>
                <div className="service-points">
                  <ul>
                    <li>Finding patterns and links in data using statistical methods</li>
                    <li>Use past data to forecast future results</li>
                  </ul>
                </div>
                <p><strong>Management of performance</strong></p>
                <div className="service-points">
                  <ul>
                    <li>Tracking and evaluating metrics related to business performance</li>
                    <li>Finding areas that need to be optimized and improved</li>
                  </ul>
                </div>
                <p><strong>Instantaneous analytics</strong></p>
                <div className="service-points">
                  <ul>
                    <li>Real-time data analysis as it is being generated</li>
                    <li>Facilitating quicker reaction and decision-making times</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-12">
            <p className="headings mt-5" style={{ textAlign: "left", color: "#f4990b" }}>PLAN</p>
            <h1>Data sources, user needs,<br /> scalability, and business<br /> objectives.</h1>
            <div className="new-para">
              <div className="d-flex">
                <div className="circle-number">1</div>
                <p>Determine the project's aims and objectives for BI or analytics.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number">2</div>
                <p>Establish the project's parameters and the sources of the data that will be used.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number">3</div>
                <p>Specify the KPIs and metrics that will be monitored.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number px-2">4</div>
                <p>Examine the data architecture as it stands now to find any holes that should be filled.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number">5</div>
                <p>Evaluate the data's completeness and quality.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number">6</div>
                <p>Establish the technology stack that the project will employ.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number">7</div>
                <p>Create a data governance and security plan.</p>
              </div>
              <div className="d-flex">
                <div className="circle-number">8</div>
                <p>Specify the project's schedule and objectives.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12 my-auto py-5">
            <img className="kl_img" src={BI_Goals} alt="" width="100%" />
          </div>
        </div>
      </div>
      <div className="background py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 my-auto py-4">
              <div className="contact-banner-heading p-lg-4  mt-4">
                <p style={{ color: "#f4990b" }}>OUR PROCESS</p>
                <h1>Our Principal Proficiencies</h1>
              </div>
            </div>
            <div className="row">
              <Slider className="d-none d-lg-block" {...settings1}>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Data_Integration} alt="" width="100%" />
                    <h3 className="mt-2">Integration and management of data</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks offers solutions for easily integrating and managing data from a variety of sources, giving users a thorough understanding of the business.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Customization} alt="" width="100%" />
                    <h3 className="mt-2">Personalization and expandability</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks can scale and modify the BI/Analytics solution to match the unique requirements of the company and make sure it is future-proof to handle expansion.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Training} alt="" width="100%" />
                    <h3 className="mt-2">Instruction and assistance</h3>
                    <p style={{ textAlign: "justify" }}>
                      To make sure that business users are properly trained and supported to use the BI/Analytics tool, Dahooks can offers training and assistance.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Security} alt="" width="100%" />
                    <h3 className="mt-2">Safety and adherence</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks can guarantee that the BI/Analytics tool complies with all applicable norms and laws and is safe.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Performance} alt="" width="100%" />
                    <h3 className="mt-2">Enhancement of performance</h3>
                    <p style={{ textAlign: "justify" }}>
                      In order to guarantee that the BI/Analytics tool delivers real-time insights and analysis for well-informed decision-making, Dahooks can optimize the tool's performance.
                    </p>
                  </div>
                </div>
              </Slider>
              <Slider className="d-none d-md-block d-lg-none" {...settings}>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Data_Integration} alt="" width="100%" />
                    <h3 className="mt-2">Integration and management of data</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks offers solutions for easily integrating and managing data from a variety of sources, giving users a thorough understanding of the business.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Customization} alt="" width="100%" />
                    <h3 className="mt-2">Personalization and expandability</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks can scale and modify the BI/Analytics solution to match the unique requirements of the company and make sure it is future-proof to handle expansion.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Training} alt="" width="100%" />
                    <h3 className="mt-2">Instruction and assistance</h3>
                    <p style={{ textAlign: "justify" }}>
                      To make sure that business users are properly trained and supported to use the BI/Analytics tool, Dahooks can offers training and assistance.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Security} alt="" width="100%" />
                    <h3 className="mt-2">Safety and adherence</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks can guarantee that the BI/Analytics tool complies with all applicable norms and laws and is safe.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Performance} alt="" width="100%" />
                    <h3 className="mt-2">Enhancement of performance</h3>
                    <p style={{ textAlign: "justify" }}>
                      In order to guarantee that the BI/Analytics tool delivers real-time insights and analysis for well-informed decision-making, Dahooks can optimize the tool's performance.
                    </p>
                  </div>
                </div>
              </Slider>
              <Slider className="d-md-none" {...settings2}>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Data_Integration} alt="" width="100%" />
                    <h3 className="mt-2">Integration and management of data</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks offers solutions for easily integrating and managing data from a variety of sources, giving users a thorough understanding of the business.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Customization} alt="" width="100%" />
                    <h3 className="mt-2">Personalization and expandability</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks can scale and modify the BI/Analytics solution to match the unique requirements of the company and make sure it is future-proof to handle expansion.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Training} alt="" width="100%" />
                    <h3 className="mt-2">Instruction and assistance</h3>
                    <p style={{ textAlign: "justify" }}>
                      To make sure that business users are properly trained and supported to use the BI/Analytics tool, Dahooks can offers training and assistance.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Security} alt="" width="100%" />
                    <h3 className="mt-2">Safety and adherence</h3>
                    <p style={{ textAlign: "justify" }}>
                      Dahooks can guarantee that the BI/Analytics tool complies with all applicable norms and laws and is safe.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 my-auto py-4 d-flex justify-content-center">
                  <div className="slide" style={{ width: "16rem" }}>
                    <img src={Performance} alt="" width="100%" />
                    <h3 className="mt-2">Enhancement of performance</h3>
                    <p style={{ textAlign: "justify" }}>
                      In order to guarantee that the BI/Analytics tool delivers real-time insights and analysis for well-informed decision-making, Dahooks can optimize the tool's performance.
                    </p>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6 col-12 my-auto">
            <div className="card-text" style={{ textAlign: "center" }}>
              <h1><strong>Outside Tools</strong></h1>
              <p style={{ textAlign: "left" }}>
                Analytics and business intelligence (BI) solutions require the use of third-party tools. These tools are produced by businesses that specialize in writing software with particular functions and goals in mind, like data management, data analysis, and data visualization.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="row">
              <div className="col-xl-6 col-md-6 col-12 d-flex justify-content-center mt-3 mt-lg-0">
                <div className=" bg-white custom-card p-3 ">
                  <h3>Compatibility with current systems</h3>
                  <p>The business's current databases, data sources, and systems should all work with the BI tool.</p>
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-12 mt-3 mt-lg-0 d-flex justify-content-center">
                <div className=" bg-white custom-card p-3">
                  <h3>Data administration and quality</h3>
                  <p>The BI tool should use precise, well-organized, and high-quality data. Additionally, the tool has to offer data management and cleaning features.</p>
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-12 mt-3 d-flex justify-content-center">
                <div className=" bg-white custom-card p-3">
                  <h3>Personalization and adaptability</h3>
                  <p>
                    In addition to offering freedom to integrate new data sources and KPIs, the BI tool should be customizable to match the particular requirements of the organization.
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-md-6 col-12 mt-3 d-flex justify-content-center">
                <div className=" bg-white custom-card p-3">
                  <h3>Access control and security</h3>
                  <p>Strong security features are required for BI tools in order to protect sensitive data, stop illegal access, and guarantee data privacy.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background py-5">
        <div className="container ">
          <div className="row" >
            <div className="col-lg-6 col-12 my-auto" >
              <div className="card-text text-center" >
                <h1><strong>Customized</strong></h1>
                <p style={{ textAlign: "left" }}>
                  In Business Intelligence (BI) and Analytics, "tailor-made solutions" refers to solutions that are specifically tailored to an organization's needs. These solutions are made to tackle the particular problems that a company has, keeping in mind its objectives, size, industry, and other factors.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="row py-5">
                <div className="col-xl-6 col-md-6 col-12 mt-3 mt-lg-0 d-flex justify-content-center">
                  <div className=" bg-white custom-card p-3 ">
                    <h3>Technology Development and Selection</h3>
                    <p>To accomplish desired results, choose and develop technologies for the analytics, reporting, and data management aspects of the system.</p>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6 col-12 mt-3 mt-lg-0 d-flex justify-content-center">
                  <div className=" bg-white custom-card p-3 ">
                    <h3>Designing User Experiences</h3>
                    <p>
                      Because user experience design makes data access and interpretation easier, it is essential to the success of business intelligence and analytics systems.
                    </p>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6 col-12 mt-3 d-flex justify-content-center">
                  <div className=" bg-white custom-card p-3">
                    <h3>Design of Data Architecture</h3>
                    <p>In data Arc design, the selection of data structure and organization can have a big impact on system speed and scalability.</p>
                  </div>
                </div>
                <div className="col-xl-6 col-md-6 col-12 mt-3 d-flex justify-content-center">
                  <div className=" bg-white custom-card p-3">
                    <h3>Evaluation and Implementation</h3>
                    <p>To guarantee a system's dependability, efficacy, and efficiency, test and optimize it completely before putting it into use.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6 col-12">
            <div><img className="kl_img" src={BI_Img2} alt="" width={"100%"} /></div>
          </div>
          <div className="col-lg-6 col-12 my-auto">
            <div className="service-content">
              <p className="headings" style={{ textAlign: "left", color: "#f4990b" }}>MEASURE</p>
              <h1>Important domains to measure are</h1>
              <AccordionItem
                title="Measures of Performance"
                content="Assessing the system's efficacy and efficiency"
                index={1}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
              />

              <AccordionItem
                title="Adoption by Users"
                content="Tracking how users interact with the system and how they use it."
                index={2}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
              />

              <AccordionItem
                title="Data Integrity"
                content="Ensuring that the data is complete, accurate, and consistent"
                index={3}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
              />
              
              <AccordionItem
                title="Business Results"
                content="Assessing BI/Analytics' effect on overarching corporate goals and objectives"
                index={4}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
              />

              <AccordionItem
                title="ROI"
                content="Finding the system's return on investment"
                index={5}
                openIndex={openIndex}
                setOpenIndex={setOpenIndex}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
